<template>
	<v-row dense>
		<v-col cols="6" sm="4" md="4" lg="3" xl="3">
			<v-tabs v-model="tab" vertical class="tabsBorder mx-1 my-1">
				<v-tab v-for="(item, index) of $options.tabItems" :key="index" class="text-capitalize">
					<!-- <v-icon left x-small> {{ item.icon }} </v-icon> -->
					{{ item.tab }}
				</v-tab>
			</v-tabs>
		</v-col>
		<v-col cols="6" sm="8" md="8" lg="9" xl="9">
			<v-tabs-items v-model="tab">
				<v-tab-item
					v-for="(item, index) of $options.tabItems"
					:key="index"
					:transition="false"
					:reverse-transition="false"
				>
					<v-card class="mx-1 my-1 tabsBorder">
						<v-card-title>{{ item.tab }}</v-card-title>
						<v-card-text>
							<component v-if="item.component" :is="item.component" />
						</v-card-text>
					</v-card>
				</v-tab-item>
			</v-tabs-items>
		</v-col>
	</v-row>
</template>
<script>
import DisplayTab from './displayTab/DisplayTab.vue';
import OrganizationTab from './organizationTab/OrganizationTab.vue';
import DefaultValuesTab from './defaultValuesTab/DefaultValuesTab.vue';

import i18n from './dictionary';

export default {
	name: `SettingTabsContent`,
	components: { DisplayTab, OrganizationTab, DefaultValuesTab },
	i18n,
	data() {
		return {
			tab: null,
		};
	},
	created() {
		this.$options.tabItems = [
			{
				tab: this.$t('organizationData'),
				component: OrganizationTab,
			},
			{
				tab: this.$t('defaultValues'),
				component: DefaultValuesTab,
			},
			{
				tab: this.$t('display'),
				component: DisplayTab,
			},
		];
	},
};
</script>

<style scoped>
.v-tab {
	justify-content: flex-start;
}
.v-tab--active {
	background-color: lightgrey;
}
.tabsBorder {
	border: 0.1em solid lightgrey;
	border-radius: 0.2em;
}
</style>
